module.exports = __webpack_public_path__ + "static/media/spanish-categories.33e95ede.jpg";